<template>
    <v-content>

        <div>
            <v-row>

                <v-col cols="3"
                       v-for="title in listDatas"
                       :key="title.id"
                       class="viewCard">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <router-link :to="`/formStructure/${title.id}` ">
                                <HoverCard :cardData="{icon:title.imageLink,name:title.value}"></HoverCard>

                            </router-link>
                        </template>
                    </v-tooltip>
                </v-col>
            </v-row>
        </div>


    </v-content>

    <!--<div>

        <table class="table tbl">
            <thead>
                <tr>
                    <th rowspan="2">S NO.</th>
                    <th rowspan="2">Report Name</th>
                    <th rowspan="2">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(listData,index) in listDatas" :key="listData.id">
                    <td>{{index+1}}</td>
                    <td>{{listData.value}}</td>
                    <td>
                        <router-link :to="`/report/${listData.id}`">
                            <v-btn color="primary">View</v-btn>
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>-->
</template>

<script>
    import axios from "axios";
    import store from "@/store";
    import HoverCard from "@/components/HoverCard";


    export default {
        name: 'LogList',
        watch: {},
        components: {
          HoverCard
        },
        data() {
            return {
                IsActive: false,
                headers: [],
                titleHeaders: [],
                listDatas: [],
                role: "",
                user: {},
            };
        },
        mounted() {
            this.getMenu(),
            this.apiData()
        },
        methods: {
            apiData() {

                axios.get('ReportSettings/DDLOwnReportList').then(response => {
                    this.listDatas = response.data
                })

            },
            nullTitle( title ) {
                return title == null
            },
            getMenu() {
                let userData = JSON.parse(store.getters.getInfo);

                this.user.name = userData.userName;
                this.role = userData.role;


            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>
